import { PaymentService } from "@/api/services/PaymentService";
import { isQrPaymentEnabled } from "@/lib/configuration/payment";
import { useQuery } from "@tanstack/react-query";

export const usePollPaymentStatus = (transactionId: string) => {
  const { data, error, isPending } = useQuery({
    queryKey: ["payment-status", transactionId],
    queryFn: () =>
      PaymentService.paymentControllerGetPaymentStatus(transactionId),
    refetchInterval: (query) => {
      if (query.state.data?.status === "PENDING") {
        const dataUpdatedAt = query.state.dataUpdatedAt;
        const elapsedTime = Date.now() - dataUpdatedAt;

        // Fast polling for first 30 seconds
        if (elapsedTime < 30_000) return 3_000;

        // Medium polling for next 90 seconds
        if (elapsedTime < 120_000) return 5_000;

        // Slower polling after 2 minutes
        if (elapsedTime < 300_000) return 10_000;
      }
      return false;
    },
    enabled: isQrPaymentEnabled() && !!transactionId,
  });

  return {
    data,
    error,
    isPending,
  };
};
